import React from 'react';

const Margin = ({ children, ...rest }) => (
  <div className="uk-margin-small ob-margin" { ...rest }>
    { children }
  </div>
);

export default Margin;
